import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { CookieService } from 'ngx-cookie-service';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class ActiveLanguageService {
    language: string;
    current: BehaviorSubject<string>;
    constructor(
        private cookieService: CookieService,
        private activatedRoute: ActivatedRoute,
        private translate: TranslateService
    ) {
        this.current = new BehaviorSubject<string>('');
        this.translate.setDefaultLang('en');

        this.activatedRoute.queryParams.subscribe(params => {
            if('language' in params) {
                this.set(params.language);
            }
        });

        if(this.cookieService.check('language')) {
            this.set(this.cookieService.get('language'));
        }
    }

    get() {
        return this.language;
    }

    set(language, emit=true) {
        // console.log('Setting Active Language', {language});
        this.language = language;
        (language) ? this.cookieService.set( 'language', language ) : this.cookieService.delete('language');;
        this.translate.use(language ? language : 'en');
        if(emit) {
            this.current.next(language);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/services/active-language.service.ts